import React from "react";
import { Link } from "react-router-dom";
import { Linkedin } from "lucide-react";
import { CONTACT_EMAIL, LINKEDIN_URL, LOGO_URL, NAV } from "../data/content";
import { OrangeButton } from "./blocks";
import { useBooking } from "../context/BookingContext";
import { OptImg } from "@/components/OptImg";

const COMMUNITY_URL = "https://login.circle.so/sign_in?request_host=intuition-business-network.circle.so";

const explore = [
  { label: "Home", to: "/" },
  { label: "IBN Network", to: "/founder-network" },
  { label: "About", to: "/about-maurice-jenkens" },
  { label: "Community", to: COMMUNITY_URL, external: true },
];

function FooterLink({ item }) {
  const cls = "text-white hover:text-embersoft text-[15px] transition-colors";
  return item.external ? (
    <a href={item.to} target="_blank" rel="noreferrer" className={cls}>{item.label}</a>
  ) : (
    <Link to={item.to} className={cls}>{item.label}</Link>
  );
}

function FooterColumn({ title, items }) {
  return (
    <div>
      <p className="font-eyebrow text-white text-xs mb-5">{title}</p>
      <ul className="space-y-3">
        {items.map((it) => (
          <li key={it.label}><FooterLink item={it} /></li>
        ))}
      </ul>
    </div>
  );
}

export default function Footer() {
  const { openBooking } = useBooking();
  return (
    <footer className="bg-ink px-6 sm:px-10 pt-24 pb-12">
      <div className="max-w-6xl mx-auto grid gap-12 md:grid-cols-6">
        <div className="md:col-span-2">
          <Link to="/" className="inline-block">
            <OptImg sizes="260px" loading="lazy" src={LOGO_URL} alt="The Intuitive Leader" className="h-10 w-auto" />
          </Link>
          <p className="text-white text-sm mt-4 max-w-xs">
            Trust your gut. Make better decisions, navigating uncertainty.
          </p>
        </div>

        <FooterColumn title="Services" items={NAV.services} />
        <FooterColumn title="Insights" items={NAV.insights} />
        <FooterColumn title="Explore" items={explore} />

        <div>
          <p className="font-eyebrow text-white text-xs mb-5">Contact</p>
          <a href={`mailto:${CONTACT_EMAIL}`} className="text-white hover:text-embersoft text-[15px] transition-colors block">
            {CONTACT_EMAIL}
          </a>
          <a href={LINKEDIN_URL} target="_blank" rel="noreferrer" className="inline-flex items-center gap-2 text-white hover:text-embersoft text-[15px] mt-3 transition-colors">
            <Linkedin className="w-4 h-4" /> LinkedIn
          </a>
          <div className="mt-6">
            <OrangeButton onClick={() => openBooking("Contact")} testid="footer-book-call" className="!py-2.5 !px-5 !text-[11px]">
              BOOK A CALL
            </OrangeButton>
          </div>
        </div>
      </div>

      <div className="max-w-6xl mx-auto mt-20 pt-8 text-white/60 text-sm flex flex-col sm:flex-row sm:items-center gap-2 sm:gap-4">
        <span>© 2026 The Intuitive Leader™ — Maurice Jenkens</span>
        <Link to="/privacy" className="hover:text-embersoft transition-colors" data-testid="footer-privacy">Privacy Policy</Link>
        <button
          type="button"
          data-testid="footer-cookie-settings"
          onClick={() => {
            try { localStorage.removeItem("il_cookie_consent"); } catch { /* ignore */ }
            window.location.reload();
          }}
          className="hover:text-embersoft transition-colors text-left"
        >
          Cookie settings
        </button>
      </div>
    </footer>
  );
}
